import { render } from "./PackagePage.vue?vue&type=template&id=27f42797"
import script from "./PackagePage.vue?vue&type=script&lang=js"
export * from "./PackagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__